/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrariPianificazioneResDto } from '../../models/orari-pianificazione-res-dto';

export interface OrariPianificazioniControllerGetOneOrarioPianificazioneById$Params {
  id: number;
}

export function orariPianificazioniControllerGetOneOrarioPianificazioneById(
  http: HttpClient,
  rootUrl: string,
  params: OrariPianificazioniControllerGetOneOrarioPianificazioneById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<OrariPianificazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    orariPianificazioniControllerGetOneOrarioPianificazioneById.PATH,
    'get',
  );
  if (params) {
    rb.path('id', params.id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrariPianificazioneResDto>;
      }),
    );
}

orariPianificazioniControllerGetOneOrarioPianificazioneById.PATH =
  '/admin/orarioPianificazione/id/{id}';
